// src/hooks/countries/useCreateCountries.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createCountry } from "../../api/apiCountries";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useCreateCountries = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate()
    const {
        mutate: createCountries,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: createCountry,
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/countries');
            queryClient.invalidateQueries({ queryKey: ["countries"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create country");
        },
    });

    return {
        createCountries,
        isPending: isPending || isLoading,
    };
};

export default useCreateCountries;
